import { Card, CardContent, Typography } from '@mui/material';
import PortfolioThumbnail from '../../components/PortfolioThumbnail';

function PublicPortfolioCard({ item }) {
  return (
    <Card
      component="a"
      href={item.contentUrl}
      target="_blank"
      rel="noreferrer"
      sx={{
        display: 'block',
        textDecoration: 'none',
        color: 'inherit',
        borderRadius: 3,
        boxShadow: '0 1px 3px rgba(20, 10, 50, 0.06)',
        overflow: 'hidden',
        transition: 'transform 0.15s ease, box-shadow 0.15s ease',
        '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 8px 20px rgba(20, 10, 50, 0.12)' },
      }}
    >
      <PortfolioThumbnail item={item} height={160} />
      <CardContent sx={{ p: 2 }}>
        <Typography fontWeight={700} noWrap>
          {item.title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {item.platform} · {item.type}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default PublicPortfolioCard;
